import { QuestionNoteJson } from './QuestionNoteJson';
import QuestionNote from './QuestionNote';

export default class QuestionNoteCollection {
  public static questionNotesForSubmission: QuestionNoteJson[] = [];

  public list = [];

  constructor(pageId, questionId) {
    const notesForThisQuestion = QuestionNoteCollection.questionNotesForSubmission.filter((row: QuestionNoteJson) => {
      return row.pageId == pageId && row.questionId == questionId;
    });
    const notes = notesForThisQuestion.sort((a: QuestionNoteJson, b: QuestionNoteJson) => {
      if (a.createdDate < b.createdDate) {
        return -1;
      } else if (b.createdDate < b.createdDate) {
        return 1;
      }
      return 0;
    });
    this.list = notes.map((noteJson) => QuestionNote.createFromValue(noteJson));
  }
}
